import getRangeItemIdsByIndexes from './get-range-items-id-by-indexes';

const getRangeItemsIds = (items, startItemId, endItemId) => {
  const startIndex = items.findIndex((item) => item.id === startItemId);
  const endIndex = items.findIndex((item) => item.id === endItemId);

  if (startIndex === -1 || endIndex === -1) {
    return [];
  }

  return startIndex > endIndex
    ? getRangeItemIdsByIndexes(items, endIndex, startIndex)
    : getRangeItemIdsByIndexes(items, startIndex + 1, endIndex + 1);
};

export default getRangeItemsIds;
